import { render, staticRenderFns } from "./Visitas.vue?vue&type=template&id=2a3d8b5c"
import script from "./Visitas.vue?vue&type=script&lang=js"
export * from "./Visitas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports